import React, {Component} from 'react'
import {Button, Row, Col, Tabs, message, Popconfirm} from 'antd';
import {Redirect, Switch, Route, withRouter} from 'react-router-dom'
import './index.less'
import OrderSpaceView from "./order-space-v";
import OrderFile from "./order-file";
import {getOrder, getOrderDelivery, reqReview} from '../../api'
import OrderBoxFile from "./order-box-file";
import OrderDeclare from "./order-declare";
import OrderShortInfoView from "./order-short-info-v";
const {TabPane} = Tabs;

let orderId = '';
class OrderInfo extends Component {
    constructor(props) {
        super(props)
        this.state = {
            order: {
                entrustingNo: '',
                containerNum: '',
                createdDt: '',
                status: '',
                transferStatus: '',
                packageManageVoList: [],
                goodsName: '',
                pcsNumber: ''
            },
            boxNo: '',
            carNo: '',
        }
    }

    componentWillMount() {
        sessionStorage.removeItem("track");
        sessionStorage.removeItem("space");
        sessionStorage.removeItem("invoice");
    }

    componentDidMount() {
        orderId = this.props.location.state.orderId;
        this.getOrderShortFunc(orderId);
        this.getOrderDeliveryFunc(orderId);
    }

    judgeReadOnly = orderStatus => {
        if (orderStatus == 'audited' || orderStatus == 'declare') {
            return false;
        }
        return true;
    };
    callback = (key) => {
        this.props.history.push(key, {orderId: orderId})
        this.setState({activeKey: key})
    }
    getOrderShortFunc = async (id) => {
        let result = await getOrder(id)
        if (result.code === 200) {
            var data = result.data;
            var status = {
                audit: '待审核',
                audited: '待订舱',
                booked: '已订舱',
                boxed: '已装箱',
                declare: '待报关',
                declaring: '报关中',
                released: '已放行'
            };
            var transferStatus = {
                waiting: '待揽货',
                transport: '运输中',
                declaring: '报关中',
                released: '已放行'
            };
            data.status = status[data.orderStatus];
            data.transferStatus = transferStatus[data.logisticsStatus]
            /*let goodsName = '';
             //let pcsNumber = 0;
             let packageManageVoList = data.packageManageVoList
             if (packageManageVoList && packageManageVoList.length > 0) {
             for (let j = 0; j < packageManageVoList.length; j++) {
             if (packageManageVoList[j].name && j <= 1) {
             goodsName = goodsName + packageManageVoList[j].name + '，';
             }
             if (packageManageVoList[j].name && j === 2) {
             goodsName = goodsName + '...' + ' ';
             }
             }
             goodsName = goodsName.substr(0, goodsName.length - 1)
             }*/
            //编辑状态时 禁用订舱单 与 附件
            const readOnly = this.judgeReadOnly(data.orderStatus);
            let activeKey = this.props.location.pathname;
            if (readOnly) {
                if (activeKey == '/orderInfo' || activeKey == '/orderInfo/file' || activeKey == '/orderInfo/space') {
                    activeKey = '/orderInfo/box-file';
                }
                this.callback(activeKey);
            }
            this.setState({
                order: data,
                // goodsName,
                readOnly,
                activeKey
            })
        } else {
            message.error(result.message)
        }
    }

    getOrderDeliveryFunc = async (id) => {
        let result = await getOrderDelivery(id)
        if (result.code === 200) {
            var data = result.data;

            if (data && data.length > 0) {
                let boxNo = '';
                let carNo = '';
                for (let i = 0; i < data.length; i++) {
                    if (data[i].boxNo) {
                        boxNo = boxNo + data[i].boxNo + ' ';
                    }
                    if (data[i].carNo) {
                        carNo = carNo + data[i].carNo + ' ';
                    }
                }

                this.setState({
                    boxNo: boxNo,
                    carNo: carNo
                })
            }

        } else {
            message.error(result.message)
        }
    }

    approveOrder = async () => {
        orderId = this.props.location.state.orderId;
        const type = 1
        let result = await reqReview(orderId, type)
        if (result.code === 200) {
            this.props.history.replace('/trackList')
        } else if (result.code === 204) {
            message.error(result.message)
        } else {
            message.error(result.message)
        }
    }

    rejectOrder = async () => {
        orderId = this.props.location.state.orderId;
        const type = 0
        let result = await reqReview(orderId, type)
        if (result.code === 200) {
            this.props.history.replace('/orderList')
        } else if (result.code === 204) {
            message.error(result.message)
        } else {
            message.error(result.message)
        }
    }

    render() {
        return (
            <div className='order-info box-shadow padding-20'>
                <div className="head-title">
                    <div className='flex-between'>
                        <span className='title' style={{lineHeight: '32px'}}>订单详情</span>
                        <span className='opt'>
                            {/*<Popconfirm title="是否确定不通过?" onConfirm={() => this.rejectOrder()}>
                             <Button style={{marginRight: '10px'}} type='default' className='failedButton'>审核不通过</Button>
                             </Popconfirm>

                             <Popconfirm title="是否确定审核通过?" onConfirm={() => this.approveOrder()}>
                             <Button type='primary'>审核通过</Button>
                             </Popconfirm>*/}
                        </span>
                    </div>
                </div>
                <OrderShortInfoView order={this.state.order}/>
                <div className='order-info-tab'>
                    <Tabs type="card" tabBarGutter={'16px'} onChange={this.callback}
                          activeKey={this.state.activeKey}>
                        <TabPane tab="订舱单" key="/orderInfo/space" disabled={this.state.readOnly}></TabPane>
                        <TabPane tab="装车照片" key="/orderInfo/file" disabled={this.state.readOnly}></TabPane>
                        <TabPane tab="资料文件" key="/orderInfo/box-file"></TabPane>
                        {/*<TabPane tab="报关单" key="/orderInfo/declare"></TabPane>*/}
                    </Tabs>
                </div>
                <div className='order-info-content'>
                    <Switch>
                        <Route path='/orderInfo/space' component={OrderSpaceView}/>
                        <Route path='/orderInfo/file' component={OrderFile}/>
                        <Route path='/orderInfo/box-file'
                               render={(props) => <OrderBoxFile {...props} readonly={false}/>}/>
                        <Route path='/orderInfo/declare'
                               render={(props) => <OrderDeclare {...props} readOnly={false}/>}/>
                        <Route component={OrderSpaceView}/>
                    </Switch>
                </div>

            </div>
        )

    }
}
export default withRouter(OrderInfo)